import { render, staticRenderFns } from "./TransparencyProgramInfo.ts.vue?vue&type=template&id=2a248b06"
import script from "./TransparencyProgramInfo.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransparencyProgramInfo.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TransparencyProgramInfo.ts.vue?vue&type=style&index=0&id=2a248b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports